export const promiseWp = function(promise) {
    return promise.then(res => [ res, null ]).catch(err => [null, err])
}


// WEBPACK FOOTER //
// ./src/comm/js/promiseExt.js